import React from 'react';
import './Footer.css';
import AkinevoLogo from '../assets/images/Akinevo.png';
import { useLanguage } from '../context/LanguageContext';

const Footer = ({ onNavigate }) => {
  const { t } = useLanguage();

  const handleNavClick = (sectionId) => {
    if (onNavigate) {
      onNavigate('home', sectionId);
    }
  };

  return (
    <footer className="modern-footer">
      <div className="footer-container">
        <div className="footer-brand-col">
          <div className="footer-logo-wrapper">
            <a href="https://akinevo.com">
              <img src={AkinevoLogo} alt="Akinevo" className="footer-logo" />
            </a>
          </div>
          <p className="footer-desc">
            {t('footer.desc')}
          </p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/company/akinevo/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a href="https://www.instagram.com/akinevo0/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://x.com/Akinevo" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <i className="fa-brands fa-x-twitter"></i>
            </a>
            <a href="https://www.tiktok.com/@akinevo" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <i className="fa-brands fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCQq0j39bhW9x38xqwAetkCw" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fa-brands fa-youtube"></i>
            </a>
          </div>
        </div>

        <div className="footer-nav-col">
          <h4>{t('footer.quickLinks')}</h4>
          <ul>
            <li><button onClick={() => handleNavClick('hero')}>{t('nav.home')}</button></li>
            <li><button onClick={() => handleNavClick('hakkinda')}>{t('nav.about')}</button></li>
            <li><button onClick={() => handleNavClick('hizmetler')}>{t('nav.services')}</button></li>
            <li><button onClick={() => handleNavClick('uygulamalar')}>{t('nav.apps')}</button></li>
            <li><button onClick={() => onNavigate && onNavigate('testimonials')}>{t('nav.testimonials')}</button></li>
            <li><button onClick={() => handleNavClick('iletisim')}>{t('nav.contact')}</button></li>
          </ul>
        </div>

        <div className="footer-contact-col">
          <h4>{t('footer.contactTitle')}</h4>
          <p><i className="fa-solid fa-envelope"></i> akinevo0@gmail.com</p>
          <p><i className="fa-solid fa-location-dot"></i> {t('contact.locationVal')}</p>
          <div className="footer-flagship-link">
            <span>{t('apps.flagshipBadge')}:</span>
            <a href="https://sacredlifex.com" target="_blank" rel="noopener noreferrer">
              sacredlifex.com <i className="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; {new Date().getFullYear()} Akinevo. {t('footer.copyright')}</p>
          <p className="built-with">Akinevo Technology Ecosystem</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
